import { render, staticRenderFns } from "./RptBasicreport.vue?vue&type=template&id=6ba0f440&scoped=true&"
import script from "./RptBasicreport.vue?vue&type=script&lang=js&"
export * from "./RptBasicreport.vue?vue&type=script&lang=js&"
import style0 from "./RptBasicreport.vue?vue&type=style&index=0&id=6ba0f440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0f440",
  null
  
)

export default component.exports